var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { CommandSocketInitializer } from './framework/CommandSocketInitializer';
import { Timeouts } from './framework/Timeouts';
export class AtenVideoSwitcher {
    constructor(socket, state, log, framework) {
        this.socket = socket;
        this.state = state;
        // other class properties and constructor
        this.timeouts = new Timeouts();
        this.busyTimeout = this.timeouts.create();
        // controls
        this.busy = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                return this.state.busy.value;
            }),
        };
        this.firmwareVersion = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                return this.state.firmwareVersion.value;
            }),
        };
        this.videoMatrixRoutes = {
            get: (key, tags) => __awaiter(this, void 0, void 0, function* () {
                return this.state.videoMatrixRoutes.values[key];
            }),
            set: (key, value, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`sw i${value} o${key}`, /o(\d+) i(\d+)|o\d+ i--|(Command OK)/i, tags);
                this.state.busy.update(true);
                this.busyTimeout.set(() => this.state.busy.update(false), 3000);
                return match[1] && match[2]
                    ? match[2]
                    : match[3]
                        ? value
                        : this.state.videoMatrixRoutes.values[key];
            }),
            asyncHandlers: [
                {
                    regExp: /o(\d+) i(\d+)/i,
                    callback: (match) => {
                        const key = match[1];
                        const value = match[2];
                        this.state.videoMatrixRoutes.update(key, value);
                    },
                },
            ],
        };
        // polling
        this.polls = [
            {
                intervalMs: 3000,
                function: () => __awaiter(this, void 0, void 0, function* () {
                    yield this.socket.sendAsync(`read`, ['poll']);
                }),
            },
        ];
    }
    // phase callbacks
    onConfigure(config) {
        return __awaiter(this, void 0, void 0, function* () {
            this.timeouts.clearAll();
            const videoMatrixRoutesAsyncId = this.socket.registerAsync(/o(\d+) i(\d+)/i, match => {
                const key = match[1];
                const value = match[2];
                this.state.videoMatrixRoutes.update(key, value);
            });
            const firmwareAsyncId = this.socket.registerAsync(/FW: V(.+), Build/i, match => {
                this.state.firmwareVersion.update(match[1]);
            });
            try {
                yield this.socket.sendAsync(`read`, ['configure']);
                // TODO: is there a command we could send here instead of waiting?
                yield this.timeouts.delay(2000); // wait to be sure we got all the responses
            }
            finally {
                this.socket.unregisterAsync(videoMatrixRoutesAsyncId);
                this.socket.unregisterAsync(firmwareAsyncId);
            }
        });
    }
    onDisconnect() {
        return __awaiter(this, void 0, void 0, function* () {
            this.timeouts.clearAll();
        });
    }
    onInitialize(credentials) {
        return __awaiter(this, void 0, void 0, function* () {
            const initializerStepsRs232 = [
                {
                    errorCode: 'verifyFailed',
                    send: 'echo on',
                    next: /Command/i,
                },
            ];
            const initializerStepsTelnet = [
                {
                    errorCode: 'verifyFailed',
                    unterminatedRegExp: /Enter Username:\s*/i,
                    next: /Enter Username:\s*/i,
                },
                {
                    errorCode: 'authFailed',
                    send: 'administrator',
                    unterminatedRegExp: /Password:\s*/i,
                    next: /Password:\s*/i,
                },
                {
                    errorCode: 'authFailed',
                    send: 'password',
                    unterminatedRegExp: /Connect|Password Successful/i,
                    next: /Connect|Password Successful/i,
                    fail: /Incorrect/i,
                },
            ];
            return yield CommandSocketInitializer.initialize(this.socket, this.socket.port === 23 ? initializerStepsTelnet : initializerStepsRs232, credentials);
        });
    }
}
// static properties
AtenVideoSwitcher.driverType = 'socketDriver';
AtenVideoSwitcher.key = '-Ls3RLKzLVRgdQm53wo7';
AtenVideoSwitcher.baseSocketOptions = {};
AtenVideoSwitcher.socketOptions = [
    Object.assign(Object.assign({}, AtenVideoSwitcher.baseSocketOptions), { port: 23 }),
    Object.assign(Object.assign({}, AtenVideoSwitcher.baseSocketOptions), { port: 4999 }),
];
